

export const keys = {
    all: ["polling-frequency-admin"],

    data: (contextGroupID: number) => [
        ...keys.all,
        "data", {
            contextGroupID
        }
    ]
};